import React from "react";
import { Box, Typography, Grid, Button, Link, List, ListItem, ListItemIcon, ListItemText, Tab, Tabs, Rating, Divider, IconButton, styled } from "@mui/material";
import StarIcon from '@mui/icons-material/Star';

import './appsection.css'

const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#ff6d75',
  },
  '& .MuiRating-iconHover': {
    color: '#ff3d47',
  },
});


function AppSectionStar(){
    return (
        <Box display={'grid'} gridTemplateColumns={"max-content auto"} sx={{ mt: 3, mb: 2,ml:2 }}>
          <div className="mr-5">
            <Typography variant="h2" textAlign={'center'} sx={{ mr: 0 }}>
             <span className="jILTFe">4,5</span>
            </Typography>
            <StyledRating size="small" classes={'color-[#01875f]'} className="color-[#01875f]" value={4.5} precision={0.1} readOnly
             icon={<StarIcon fontSize="inherit" style={{ color:'#01875f' }} />}
            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />} />
            <Typography variant="body2" mt={2} fontSize={'10px'} color="text.secondary" ml={1}>
              1,72 jt ulasan
            </Typography>
          </div>
          {/* Star Distribution */}
          <Box >
            {[5, 4, 3, 2, 1].map((star) => (
              <Box sx={{ mb: 0 }} display={'grid'} alignItems={'center'} gridTemplateColumns={"max-content auto"}>
                <div className="mr-4">
                  <Typography variant="body2" color="rgb(95,99,104)">{star} </Typography>
                </div>
                <div className="w-full relative bg-[rgb(232,234,237)] " style={{ borderRadius: '9999px' }}>
                  <Box
                    display={'grid'} gridTemplateColumns={"max-content auto"}
                    sx={{
                      height: 10,
                      bgcolor: "#01875f",
                      borderRadius: 4,
                      width: `${star === 5 ? 80 : star === 4 ? 60 : star === 3 ? 30 : 10}%`,
                    }}
                  />
                </div>

              </Box>
            ))}
          </Box>
        </Box>
    )
}
export default AppSectionStar